var React = require('react');

function SlideArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.9 0H11.9427L0 17L11.9427 34H14.9L3.0707 17L14.9 0Z","fill":"currentColor"}));
}

SlideArrowLeft.defaultProps = {"width":"15","height":"34","viewBox":"0 0 15 34","fill":"none"};

module.exports = SlideArrowLeft;

SlideArrowLeft.default = SlideArrowLeft;
